import { render, staticRenderFns } from "./StatusEdit.vue?vue&type=template&id=ba07b5f6&scoped=true"
import script from "./StatusEdit.vue?vue&type=script&lang=js"
export * from "./StatusEdit.vue?vue&type=script&lang=js"
import style0 from "./StatusEdit.vue?vue&type=style&index=0&id=ba07b5f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba07b5f6",
  null
  
)

export default component.exports